import React, { useState, useContext } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Journey, PageAbsolutePath } from '../../consts/Common';
import UsefulDocuments from '../sitePages/UsefulDocuments';
import PageInfoPlanSummary from '../sitePages/PageInfoPlanSummary';
import PageInfoProduct from '../sitePages/PageInfoProduct';
import PageInfoCreatePlan from '../sitePages/PageInfoCreatePlan';
import PageInfoVehicle from '../sitePages/PageInfoVehicle';
import { DocumentView } from './Constants';
import { DocumentTreeItem, ProductType } from './CommonTypes';
import { SiteContext } from '../../context/SiteContext';

type PageInfoProps = {
  documents: DocumentTreeItem[];
  expandedDocIds: string[];
  products: ProductType[];
  currentPath: string;
  setExpandedDocIds: (docIds: string[]) => void;
};

const MobileInfoBar = ({
  documents,
  expandedDocIds,
  products,
  currentPath,
  setExpandedDocIds
}: PageInfoProps): JSX.Element => {
  const [expanded, setExpanded] = useState<boolean>(true);
  const { site } = useContext(SiteContext);
  const cms = site.content;

  const isCCWUser: boolean =
    site.journeyType === Journey.Customer && !!site.user?.userId;

  const handleChange = () => setExpanded(!expanded);

  const getPanelHeading = () => {
    switch (currentPath) {
      case PageAbsolutePath.VehicleDetails:
        return 'More information';
      case PageAbsolutePath.Products:
        return 'More information';
      case PageAbsolutePath.CreatePlan:
        return 'More information';
      case PageAbsolutePath.PersonalDetails:
      case PageAbsolutePath.Summary:
      case PageAbsolutePath.DirectDebit:
      case PageAbsolutePath.SinglePayment:
        return 'Customer plan';
      default:
        return '';
    }
  };

  const getAccordionContent = () => {
    switch (currentPath) {
      case PageAbsolutePath.VehicleDetails:
      case PageAbsolutePath.Customer.VehicleDetails:
        return (
          <>
            <PageInfoVehicle showReasonsToProtect={!isCCWUser} />
            <UsefulDocuments
              documents={documents}
              cmsDocuments={cms.usefulDocuments}
              view={DocumentView.Mobile}
              expandedDocIds={expandedDocIds}
              setExpandedDocIds={setExpandedDocIds}
              showDivider={true}
            />
          </>
        );
      case PageAbsolutePath.Products:
      case PageAbsolutePath.Customer.Products:
        return (
          <>
            <PageInfoProduct showReasonsToProtect={!isCCWUser} />
            <UsefulDocuments
              documents={documents}
              cmsDocuments={cms.usefulDocuments}
              view={DocumentView.Mobile}
              expandedDocIds={expandedDocIds}
              setExpandedDocIds={setExpandedDocIds}
              showDivider={true}
            />
          </>
        );
      case PageAbsolutePath.CreatePlan:
      case PageAbsolutePath.Customer.CreatePlan:
        return (
          <>
            <PageInfoCreatePlan showReasonsToProtect={!isCCWUser} />
            <UsefulDocuments
              documents={documents}
              cmsDocuments={cms.usefulDocuments}
              view={DocumentView.Mobile}
              expandedDocIds={expandedDocIds}
              setExpandedDocIds={setExpandedDocIds}
              showDivider={true}
            />
          </>
        );
      case PageAbsolutePath.PersonalDetails:
      case PageAbsolutePath.Summary:
      case PageAbsolutePath.DirectDebit:
      case PageAbsolutePath.SinglePayment:
      case PageAbsolutePath.Customer.PersonalDetails:
      case PageAbsolutePath.Customer.Summary:
      case PageAbsolutePath.Customer.DirectDebit:
      case PageAbsolutePath.Customer.SinglePayment:
        return (
          <>
            {cms.common?.hideCustomerPlan !== true && (
              <PageInfoPlanSummary
                products={products}
                culture={site.cultureCode}
              />
            )}
            <UsefulDocuments
              documents={documents}
              cmsDocuments={cms.usefulDocuments}
              view={DocumentView.Mobile}
              expandedDocIds={expandedDocIds}
              setExpandedDocIds={setExpandedDocIds}
              showDivider={false}
            />
          </>
        );
      default:
        return '';
    }
  };

  const getContentClass = () => {
    let contentClass = 'mobile-content-info page-info-container';
    if (
      currentPath === PageAbsolutePath.PersonalDetails ||
      currentPath === PageAbsolutePath.Summary ||
      currentPath === PageAbsolutePath.DirectDebit ||
      currentPath === PageAbsolutePath.SinglePayment
    ) {
      contentClass = 'mobile-content-info';
    }
    return contentClass;
  };

  return (
    <div>
      <div
        className='desktop-hide'
        style={{
          boxShadow: '0px -1px 0px #eeeeee',
          paddingTop: '30px',
          marginTop: '30px',
          fontSize: '22px'
        }}>
        <Accordion expanded={expanded} onChange={handleChange}>
          <AccordionSummary
            id='mobile-more-information'
            expandIcon={
              <span style={{ float: 'right' }}>
                <ExpandLessIcon />
              </span>
            }>
            <span>{getPanelHeading()}</span>
          </AccordionSummary>
          <AccordionDetails>
            {<div className={getContentClass()}>{getAccordionContent()}</div>}
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default MobileInfoBar;
